import { Card, CardContent, CardHeader, Grid } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { FormTextFieldPassword } from "../../../../components/common/form-text-field-password";
import { FormTextFieldPasswordConfirmation } from "../../../../components/common/form-text-field-password-confirmation";
import { useAuthContext } from "../../../../context/use-auth-context";

export const UpdatePasswordCard = () => {
  const { currentUser } = useAuthContext();
  const { t } = useTranslation(["users", "profile"]);

  if (!currentUser) return;
  return (
    <Card elevation={0}>
      <CardHeader subheader={t("profile:profile.update.password.card.sub.title")} title={t("profile:profile.update.password.card.title")} />
      <CardContent>
        <Grid container spacing={2}>
          <Grid xs={12}>
            <FormTextFieldPassword inputProps={{ autoComplete: "new-password" }} />
          </Grid>
          <Grid xs={12}>
            <FormTextFieldPasswordConfirmation
              inputProps={{ autoComplete: "new-password" }}
              onPaste={(e) => {
                e.preventDefault();
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
